
import { Component, Vue, Ref } from 'vue-property-decorator'
import { ClueService } from '@/services'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'

@Component({
    name: 'clue-table',
    components: {
        ScrollTo
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType
    private pageIndex = 1
    private pageTotal = 0
    private pageSize = 50
    private list = []
    private userId!: string

    created() {
        this.userId = this.$route.params.id
    }
    mounted() {
        this.getClueList()
    }
    // 线索广场报料
    async getClueList() {
        const params = {
            user_id: this.userId,
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        
        const result = await ClueService.getClueList(params)
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.list = result.data.list
        }
    }

    _formatStatus(row: any, col: any, value: number) {
        const map = {
            0: '未审核',
            1: '通过',
            2: '不通过'
        }
        return Reflect.get(map, value)
    }

    onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.scrollEl.scrollToTop(this.getClueList)
    }
}
